import clsx from "clsx";
import { func, number, string } from "prop-types";

import styles from "./RequirementsBadge.module.scss";

const requirementNoun = (length) =>
  length === 1 ? "requirement" : "requirements";

const RequirementsBadge = ({ length, onClick, title }) => {
  const tooltip = `${length} ${requirementNoun(length)} traced`;
  const content = (
    <>
      R<span className={styles.count}>{length}</span>
    </>
  );

  if (!onClick) {
    return (
      <span className={styles.badge} title={tooltip} aria-hidden>
        {content}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={clsx(styles.badge, styles.clickable)}
      aria-label={`Trace ${length} ${requirementNoun(length)} for ${title}`}
      title={tooltip}
      onClick={onClick}
    >
      {content}
    </button>
  );
};

RequirementsBadge.propTypes = {
  length: number,
  onClick: func,
  title: string,
};

export default RequirementsBadge;
